import { useRef, useState } from "react";
import { NavLink } from "react-router-dom";

const slug = (s) => s.replace(/[^a-z0-9]/gi, "-").toLowerCase();

// Barra recolhida (desktop): só ícones; nome/subitens aparecem num painel flutuante ao passar o mouse.
export const CollapsedNav = ({ menu }) => {
  const [fly, setFly] = useState(null);
  const timer = useRef(null);
  const show = (e, m) => {
    clearTimeout(timer.current);
    const r = e.currentTarget.getBoundingClientRect();
    setFly({ m, top: r.top });
  };
  const hide = () => { timer.current = setTimeout(() => setFly(null), 150); };
  const keep = () => clearTimeout(timer.current);
  const itemCls = ({ isActive }) =>
    `h-10 w-10 mx-auto grid place-items-center rounded-lg transition-colors ${isActive ? "bg-emerald-600 text-white" : "text-slate-600 hover:bg-slate-900/5 hover:text-slate-900"}`;

  return (
    <nav className="flex-1 overflow-y-auto overflow-x-hidden py-2 space-y-1" data-testid="sidebar-collapsed-nav">
      {menu.map((m, idx) => m.itens ? (
        <button key={idx} type="button" onMouseEnter={(e) => show(e, m)} onMouseLeave={hide} onFocus={(e) => show(e, m)}
          data-testid={`nav-collapsed-group-${slug(m.label)}`} aria-label={m.label}
          className="h-10 w-10 mx-auto grid place-items-center rounded-lg text-slate-600 hover:bg-slate-900/5 hover:text-slate-900 transition-colors">
          <m.icon size={18} />
        </button>
      ) : (
        <NavLink key={m.to} to={m.to} end={m.to === "/"} aria-label={m.label} className={itemCls}
          onMouseEnter={(e) => show(e, m)} onMouseLeave={hide} onClick={() => setFly(null)}
          data-testid={`nav-collapsed-${slug(m.label)}`}>
          <m.icon size={18} />
        </NavLink>
      ))}
      {fly && (
        <div onMouseEnter={keep} onMouseLeave={hide} style={{ top: fly.top }}
          className="fixed left-[60px] z-50 pl-2 animate-in fade-in slide-in-from-left-1 duration-150" data-testid="sidebar-flyout">
          <div className="bg-white border border-slate-200 shadow-lg rounded-lg py-1 min-w-[190px]">
            <div className={`px-3 py-1.5 text-sm font-semibold text-slate-800 ${fly.m.itens ? "border-b border-slate-100 mb-1" : ""}`}>{fly.m.label}</div>
            {fly.m.itens?.map((s) => (
              <NavLink key={s.to} to={s.to} onClick={() => setFly(null)} data-testid={`nav-flyout-${slug(s.label)}`}
                className={({ isActive }) => `flex items-center gap-2 px-3 py-2 text-sm ${isActive ? "text-emerald-700 font-semibold bg-emerald-50" : "text-slate-700 hover:bg-slate-50"}`}>
                <s.icon size={14} /> {s.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};
